



















































import Vue from 'vue';
import Layout from '@/layouts/_BlankCentredLayout.vue';
import { LOGIN_REQUEST } from '@/use-cases/user-auth/AuthModule';

export default Vue.extend({
  name: 'Login',
  components: {
    Layout,
  },
  data() {
    return {
      email: '',
      password: '',
      error: '',
    };
  },
  computed: {
    isValid(): boolean {
      return !!(this.email && this.password);
    },
    isLoading(): boolean {
      return this.$store.state.auth.status === 'loading';
    },
  },
  methods: {
    onClickSignUp() {
      this.$router.push('signup');
    },
    onClickLogin() {
      const command = {
        email: this.email,
        password: this.password,
      };
      this.$store.dispatch(LOGIN_REQUEST, command)
        .then(() => {
          this.$router.push('/');
        })
        .catch(() => {
          this.error = 'Email or password are incorrect';
        });
    },
  },
});
